import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";

const STORAGE_KEY = "njc_cookie_notice_dismissed_v1";

/**
 * Small functional-cookie notice for the login page.
 *
 * AVG-context: deze app gebruikt alleen functionele cookies (JWT-sessie).
 * Functionele cookies vereisen geen voorafgaande toestemming, maar het is
 * goed gebruik om de bezoeker hier expliciet op te wijzen. Eenmalig
 * dismissable via localStorage.
 */
export default function CookieNotice() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; }
    catch { return false; }
  });

  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div
      className="fixed bottom-4 right-4 max-w-sm z-40 bg-white border-2 border-zinc-900 rounded-sm shadow-xl p-4"
      data-testid="cookie-notice"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <Cookie size={22} weight="duotone" className="text-[#1E88E5] shrink-0 mt-0.5" />
        <div className="flex-1 text-sm text-zinc-700 leading-relaxed pr-1">
          We gebruiken alleen <strong>functionele cookies</strong> die nodig zijn om je
          ingelogd te houden. Geen tracking, geen reclame.
          {" "}
          <Link
            to="/privacy"
            className="underline font-medium hover:text-zinc-900"
            data-testid="cookie-notice-privacy-link"
          >
            Meer info
          </Link>.
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Melding sluiten"
          data-testid="cookie-notice-dismiss"
          className="-mt-1 -mr-1 p-1 text-zinc-500 hover:text-zinc-900 hover:bg-zinc-100 rounded-sm transition-colors"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
